import React, { useEffect, useState } from 'react'
import { AccordionContext } from './AccordionContext'
import { AccordionHeader } from './components/AccordionHeader'
import { AccordionBody } from './components/AccordionBody'
import classNames from 'classnames'
import './Accordion.scss'

export const Accordion = ({ className, children, visible: accordionVisible = false, disabled, disableToggle, customToggle, ...r }) => {
  const [visible, setVisible] = useState(accordionVisible)

  useEffect(() => {
    setVisible(accordionVisible)
  }, [accordionVisible])

  const classes = classNames('accordion relative w-100', { 'pointer-events-none opacity-40': disabled }, className)

  const toggle = () => (customToggle ? customToggle() : setVisible(prev => !prev))

  return (
    <AccordionContext.Provider
      value={{
        visible,
        disableToggle,
        toggle,
      }}
    >
      <div className={classes} {...r}>
        {children}
      </div>
    </AccordionContext.Provider>
  )
}

export default Accordion

Accordion.Header = AccordionHeader
Accordion.Body = AccordionBody
